<template>
  <div class="home">
    <VoiceRecorder />
  </div>
</template>

<script>
export default {
  components: {
    VoiceRecorder: () => import("@/components/VoiceRecorder"),
  },
};
</script>

<style lang="scss" scoped>
.home{
  height: 100%;
  overflow: hidden;
}
</style>
